import React from 'react';
import classes from './StatusCell.module.css';

const StatusCell = ({ value }) => {

    const status = String(value)?.toLowerCase();

    return (
        <div className={classes.statusCell}>
            <span className={classes.statusBadge} data-status={status}>
                {value}
            </span>
        </div>
    );
};

export default StatusCell;
